import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import axios from "axios";
import "./App.css";
import Homepage from "./containers/homepage";
import LoadingInd from "./components/LoadingInd";
import UserProP from "./pages/userProP";
//import h from './pages/h'
import Navv from "./components/navbar";
import { ToastContainer } from "react-toastify";
import Mypro from "./components/mypro";

function App() {
  const [users, setUsers] = useState([
    {
      id: 1,
      username: "blake",
      profileImage:
        "http://next-curriculum-instagram.s3.amazonaws.com/idol2-blake.jpg",
    },
    {
      id: 2,
      username: "ryanG",
      profileImage:
        "http://next-curriculum-instagram.s3.amazonaws.com/idol1-ryan.jpg",
    },
    {
      id: 3,
      username: "bigfan",
      profileImage:
        "http://next-curriculum-instagram.s3.amazonaws.com/bigfan-9AE7468E-4C35-41D1-AA68-31939891B5E1.png",
    },
  ]);
  const [isLoadin, setLoadin] = useState(true);
  const jwt = localStorage.getItem("token");

  useEffect(() => {
    axios
      .get("https://aqueous-plains-06808.herokuapp.com/api/v1/users/", {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((res) => {
        setLoadin(false);
        setUsers(res.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ToastContainer />
      <Navv />
      <Route path="/myProfile" component={Mypro} />
      <Route
        exact
        path="/"
        render={() =>
          isLoadin ? <LoadingInd w={70} h={70} /> : <Homepage h={users} />
        }
      />
      <switch>
        <Route path="/users/:id" component={UserProP} />
      </switch>
    </div>
  );
}
export default App;
